import React from 'react';
import { bool, instanceOf, string, object } from 'prop-types';
import { api } from '../../../../api/requestor';
import Order from './Order';
import { isDefaultAccountSpa, orderParams } from '../../helpers';
/**
 * Заказ
 */
class OrderContainer extends React.PureComponent {
  static propTypes = {
    orderId: string,
    datetimeAction: instanceOf(Date),
    isBlaBlaCar: bool,
    isShowDownloadBtn: bool,
    routes: object
  };
  state = {
    isDeleted: false,
    isExtended: false,
    errorText: ''
  };
  /**
  * Удаление заказа
  */
  destroy = () => {
    this.setState({
      isDeleted: true
    });
    api.destroy.account.order(this.props.orderId).then(({
      errors
    }) => {
      if (errors) this.setState({
        isDeleted: false
      });
    });
  };
  /**
  * Восстановление заказа
  */
  restore = () => {
    this.setState({
      isDeleted: false
    });
    api.post.account.orderRestore(this.props.orderId).then(({
      errors
    }) => {
      if (errors) this.setState({
        isDeleted: true
      });
    });
  };
  /**
  * Возврат кэшбукинг
  */
  cashBookingRefund = () => {
    const params = {
      orderRef: this.props.orderId,
      orderToken: {
        order_token: orderParams?.order_token
      }
    };
    this.setState({
      errorText: ''
    });
    api.post.account.returnCashBooking(params).then(({
      errors
    }) => {
      if (errors) {
        return this.setState({
          errorText: I18n.t('layout.main_menu.login_form.errors.default_error')
        });
      }
      return global.location.reload();
    });
  };
  toggleSegmentDetails = () => this.setState(({
    isExtended
  }) => ({
    isExtended: !isExtended
  }));
  render() {
    const {
      isExtended,
      errorText
    } = this.state;
    const {
      isBlaBlaCar,
      isShowDownloadBtn,
      routes
    } = this.props;
    return /*#__PURE__*/React.createElement(Order, {
      ...this.props,
      actions: {
        delete: this.destroy,
        restore: this.restore,
        cashBookingRefund: this.cashBookingRefund
      },
      toggleSegmentDetails: this.toggleSegmentDetails,
      isDeleted: this.state.isDeleted,
      isButtonBuyShown: isDefaultAccountSpa,
      isButtonDownloadShown: isDefaultAccountSpa || isShowDownloadBtn,
      isButtonCommentShown: isDefaultAccountSpa,
      isButtonSearchShown: isDefaultAccountSpa,
      isDeleteButtonShown: isDefaultAccountSpa,
      isExtended: isExtended,
      isBlaBlaCar: isBlaBlaCar,
      errorText: errorText,
      routes: routes
    });
  }
}
export default OrderContainer;